var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox check-info"},[_c('input',{attrs:{"type":"checkbox","disabled":"disabled"},domProps:{"checked":_vm.checked}}),_c('label',{staticClass:"form-check-label",class:{
    'text-danger': this.checked == undefined && _vm.highlightError
  }},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }